import React, {Component} from 'react';
import Modal from "../../../src/component/modal/ModalTemplate";

import SingleButton from "../button/SingleButton";
import TextInput from "../input/TextInput";
import * as apiUtil from "../../util/apiUtil";
import Loading from "../loading/Loading";

class AppRequestModal extends Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);
        this.setValue = this.setValue.bind(this);
        this.setListValue = this.setListValue.bind(this);
        this.validate = this.validate.bind(this);
        this.addUrl = this.addUrl.bind(this);
        this.deleteUrl = this.deleteUrl.bind(this);
        this.ajaxRequestWebapp = this.ajaxRequestWebapp.bind(this);

        this.state = {
            loading: false,
            webappReqList: [],
            urlName: "",
            urlValue: "",
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            true
            // this.state.loading !== nextState.loading
            // || this.state.webappReqList.length !== nextState.webappReqList.length
            // || this.state.urlName !== nextState.urlName
            // || this.state.urlValue !== nextState.urlValue
            // || this.props.isOpen !== nextProps.isOpen
        );
    }

    setLoading() {
        const { loading } = this.state;
        this.setState({ loading: !loading });
    }

    setValue(id, value) {
        switch (id) {
            case "urlName":
                this.setState({urlName: value});
                break;
            case "urlValue":
                this.setState({urlValue: value});
                break;
        }
    }

    setListValue(id, value) {
        let label = id.split("_")[0];
        let index = id.split("_")[1];

        let newLabel = '';
        if (label === 'urlName') {
            newLabel = 'name';
        } else if (label === 'urlValue') {
            newLabel = 'value';
        }

        this.setState((prevState) => {
            const newList = [...prevState.webappReqList];
            newList[index][newLabel] = value;

            return { webappReqList: newList };
        })
    }

    addUrl() {
        const { urlName, urlValue } = this.state;

        if (! this.validate()) {
            return;
        }

        this.setState((prevState) => ({
            urlName: "",
            urlValue: "",
            webappReqList: [
                ...prevState.webappReqList,
                { name: urlName, value: urlValue },
            ]
        }))
    }

    validate() {
        const { webappReqList, urlName, urlValue } = this.state;
        if (! urlName) {
            alert("URL 등록명이 입력되지 않았습니다.");
            return false;
        }

        if (! urlValue) {
            alert("URL이 입력되지 않았습니다.");
            return false;;
        }

        if (webappReqList.length === 10) {
            alert("URL 등록 요청은 10개까지 작성 가능합니다.");
            return false;;
        }

        return true;
    }

    deleteUrl(index) {
        this.setState((prevState) => ({
            webappReqList: prevState.webappReqList.filter((_, i) => i !== index)
        }));
    }

    ajaxRequestWebapp() {
        if (! window.confirm("앱/웹 등록을 요청하시겠습니까?")) {
            return;
        }

        const { webappReqList } = this.state;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/category/ats/webapp/request",
            method: apiUtil.requestMethod.POST,
            data: {
                webappReqList : webappReqList,
            },
            success: (result) => {
                alert("앱/웹 등록 요청이 완료되었습니다.")
                const { handleClose } = this.props;
                handleClose();
            }
        });
    }

    render() {
        const { isOpen, handleClose } = this.props;

        const { setValue, setListValue, addUrl, deleteUrl } = this;
        const { loading, webappReqList, urlName, urlValue } = this.state;

        const { ajaxRequestWebapp } = this;

        return (
            <Modal
                open={isOpen}
                handleClose={handleClose}
                className="react-modal"
                modalTitle="앱/웹 등록 요청"
                overlayClassName="modal-overlay"
            >
                <Loading loading={loading}/>
                <div className='modal-body p-3'>
                    <div>
                        <h5 className="mb-1">꼭 읽어주세요!</h5>
                        <p className="p-0 text-light-gray mb-2" style={{ fontSize: 13 }}>
                            - 홈페이지 내 상세페이지는 등록할 수 없습니다.<br/>
                            &nbsp;&nbsp;비즈팅 홈페이지 - https://www.bizting.co.kr(O)<br/>
                            &nbsp;&nbsp;비즈팅 홈페이지 내 마이페이지 - https://www.bizting.co.kr/mypage(X)<br/>
                            &nbsp;&nbsp;따라서 네이버 카페 및 스마트스토어 상세 페이지는 등록하실 수 없습니다.<br/>
                            - 명칭과 링크를 정확하게 입력해주세요. 정확하게 입력하지 않거나, 상세페이지 입력 시 등록되지 않습니다.<br/>
                            <span style={{ color: 'red' }}>
                                - 등록 후 반영까지 1~2달 정도의 시간이 소요됩니다.
                            </span>
                        </p>
                    </div>
                    <div className="p-2" style={{ border: '1px solid lightgray', borderRadius: '5px', height: 450, overflow: 'auto' }}>
                        <div className='mb-3 d-flex'>
                            <TextInput
                                className={`form-control me-2`}
                                type="text"
                                id="urlName"
                                onChange={setValue}
                                placeholder={"등록명을 정확하게 입력해주세요."}
                                value={urlName}
                            />
                            <TextInput
                                className={`form-control me-2`}
                                type="text"
                                id="urlValue"
                                onChange={setValue}
                                placeholder={"URL 을 정확하게 입력해주세요."}
                                value={urlValue}
                            />
                            <SingleButton
                                className={`btn btn-primary`}
                                label="+"
                                handleClick={addUrl}
                            />
                        </div>
                        {
                            webappReqList.map((item, index) =>
                                <div className="mb-1 d-flex" key={index}>
                                    <TextInput
                                        className={`form-control me-2`}
                                        type="text"
                                        id={`urlName_${index}`}
                                        value={item.name}
                                        // readOnly={true}
                                        onChange={setListValue}
                                    />
                                    <TextInput
                                        className={`form-control me-2`}
                                        type="text"
                                        id={`urlValue_${index}`}
                                        value={item.value}
                                        // readOnly={true}
                                        onChange={setListValue}
                                    />
                                    <SingleButton
                                        className={`btn btn-primary`}
                                        label="X"
                                        handleClick={() => deleteUrl(index)}
                                    />
                                </div>
                            )
                        }
                    </div>
                </div>
                <div className='modal-footer'>
                    <SingleButton
                        label="닫기"
                        className="btn btn-secondary btn-md me-2"
                        handleClick={handleClose}
                    />
                    <SingleButton
                        label="확인"
                        className="btn btn-primary btn-md"
                        handleClick={ajaxRequestWebapp}
                    />
                </div>
            </Modal>
        )
    }
}


AppRequestModal.defaultProps = {
    isOpen: false,
    handleClose: function() {},
}

export default AppRequestModal;
